import React, { useRef, memo, useCallback, useEffect } from "react";
import { MenuIcon } from "components/AppHeader/Mobile/MobileHeader";
import styled from "styled-components/macro";
import { useDispatch, useSelector } from "react-redux";
import { setTogglePressed, selectIsToggled } from "../drawerSlice";
import Drawer from "./Drawer";
/* eslint-disable */
const NavDrawerToggleButton = () => {
  const togglerRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const isToggled = useSelector(selectIsToggled);

  useEffect(() => {
    togglerRef.current?.classList.toggle("on");
  }, [isToggled]);

  const onToggleClick = () => {
    showDrawer(!isToggled);
  };

  const onClickOutside = useCallback(() => {
    showDrawer(false);
  }, []);

  const showDrawer = (flag: boolean) => {
    window.scrollTo(0, 0);
    dispatch(setTogglePressed(flag));
  };

  return (
    <>
      <MenuIcon onClick={onToggleClick}>
        <Toggler ref={togglerRef} className="toggle-mnu hidden-lg on">
          <span></span>
        </Toggler>
      </MenuIcon>
      <Drawer isToggled={isToggled} onClickOutside={onClickOutside} />
    </>
  );
};
export default memo(NavDrawerToggleButton);

const Toggler = styled.div`
  &.toggle-mnu {
    display: block;
    width: 28px;
    height: 28px;
    margin-top: 9px;
  }
  &.toggle-mnu span:after,
  &.toggle-mnu span:before {
    content: "";
    position: absolute;
    left: 0;
    top: 9px;
  }
  &.toggle-mnu span:after {
    top: 18px;
  }
  &.toggle-mnu span {
    position: relative;
    display: block;
  }
  &.toggle-mnu span,
  &.toggle-mnu span:after,
  &.toggle-mnu span:before {
    width: 100%;
    height: 2px;
    background-color: #fff;
    transition: all 0.3s;
    backface-visibility: hidden;
    border-radius: 2px;
  }
  &.toggle-mnu.on span {
    background-color: transparent;
  }
  &.toggle-mnu.on span:before {
    transform: rotate(45deg) translate(-1px, 0px);
  }
  &.toggle-mnu.on span:after {
    transform: rotate(-45deg) translate(6px, -7px);
  }
`;
